export const aciLaundryAdditionalCharges = {
    iconName: 'laundry-additional-charges',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M4.215 5.656c0-.895.725-1.62 1.62-1.62h12.33c.894 0 1.62.725 1.62 1.62v7.285a.5.5 0 11-1 0V5.656a.62.62 0 00-.62-.62H5.834a.62.62 0 00-.62.62v14.57c0 .343.278.621.62.621h6.906a.5.5 0 110 1H5.836a1.62 1.62 0 01-1.621-1.62V5.655z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M6.457 6.777a.5.5 0 01.5-.5h2.242a.5.5 0 010 1H6.957a.5.5 0 01-.5-.5zM4.215 9.02a.5.5 0 01.5-.5h14.57a.5.5 0 110 1H4.715a.5.5 0 01-.5-.5zM7.578 15.184a4.423 4.423 0 017.925-2.701.5.5 0 01-.792.611 3.423 3.423 0 10-2.71 5.513.5.5 0 010 1 4.423 4.423 0 01-4.423-4.422zM13.12 6.996a.22.22 0 100-.44v-.56a.78.78 0 000 1.56v-.56z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M13.12 5.996a.78.78 0 110 1.56v-.56a.22.22 0 110-.44v-.56zM16.483 6.996a.22.22 0 100-.44v-.56a.78.78 0 100 1.56v-.56z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M16.483 5.996a.78.78 0 110 1.56v-.56a.22.22 0 110-.44v-.56zM12 14c-.314 0-.614.124-.836.346m0 0a1.181 1.181 0 00-.346.835.5.5 0 01-1 0A2.182 2.182 0 0112 13a.5.5 0 110 1M15.6 15.675c.236-.194.532-.3.838-.3h1.236a.5.5 0 010 1h-1.236a.317.317 0 00-.278.467.316.316 0 00.16.142l1.255.502a1.316 1.316 0 01-.49 2.537H15.85a.5.5 0 110-1h1.234a.317.317 0 00.119-.609l-1.255-.501a1.317 1.317 0 01-.348-2.238z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M16.766 14.918a.5.5 0 01.5.5v.456a.5.5 0 11-1 0v-.456a.5.5 0 01.5-.5zM16.766 19.023a.5.5 0 01.5.5v.456a.5.5 0 11-1 0v-.456a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M13.832 14.766a4.148 4.148 0 115.866 5.866 4.148 4.148 0 01-5.866-5.866zm2.933-.215a3.148 3.148 0 100 6.295 3.148 3.148 0 000-6.295z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
